import _ from 'lodash';
import { insuranceDatas } from '../datas/insurance-products';
import Http from '../libs/http';

export default {

  /**
   * 获取保险列表数据
   * @param {String} regionName 区域名字
   * @param {Number} currentPage 页码
   * @param {Number} pageSize 单页显示条数
   * @return {Promise}
   */
  getInsuranceList(regionName, currentPage, pageSize) {
    return new Promise((resolve, reject) => {
      let resultArr = [...insuranceDatas];

      // 如果有区域名字代表在过滤
      if (regionName) {
        resultArr = _.filter(resultArr, insurance => insurance.region === regionName);
      }

      const pageData = this.getPageInsuranceDatas(resultArr, currentPage, pageSize);

      if (pageData && pageData.length > 0) {
        resolve({
          totalCount: resultArr.length,
          pageData,
        });
      } else {
        // 一定是有数据,如果没有就是出错了
        reject(new Error('data error'));
      }
    });
  },

  /**
   * 根据所有保险数据获取当前的页码数据
   * @param {Array} insuranceDatas 保险数据列表
   * @param {Number} currentPage 当前页码
   * @param {Number} pageSize 单页显示条数
   * @param {Array}
   */
  getPageInsuranceDatas(insuranceDatas, currentPage, pageSize) {
    let result = [];

    if (insuranceDatas && insuranceDatas.length > 0 && currentPage && pageSize) {
      // 将所有保险的列表按照单页显示条数分块 _.chunk(['a', 'b', 'c', 'd'], 2); // => [['a', 'b'], ['c', 'd']]
      const chunks = _.chunk(insuranceDatas, pageSize);

      // 当前页的编号要小于等于分块的长度
      if (chunks.length >= currentPage) {
        result = chunks[currentPage - 1];
      }
    }

    return result;
  },

  /**
   * 创建保险区域过滤数组
   * @return {Array}
   */
  createInsuranceRegionFilterArray() {
    const result = [];

    if (insuranceDatas && insuranceDatas.length > 0) {
      // 加入默认
      result.push({
        name: '全部地区',
        value: '',
        count: insuranceDatas.length,
      });

      _.forEach(insuranceDatas, (insurance) => {
        // 找到当前是否已经存在这个地区
        const regionIndex = _.findIndex(result, { name: insurance.region });

        if (regionIndex > -1) {
          // 如果找到就计数加一
          result[regionIndex].count += 1;
        } else {
          result.push({
            name: insurance.region,
            value: insurance.region,
            count: 1,
          });
        }
      });
    }

    return result;
  },
  /**
   * 获取保险数据销量
   * @return {Promise}
   */
  getInsuranceSales() {
    return Http.post('/sys/insurance_brief_query', {});
  },

  /**
   * 搜索保险
   * @param {String} insuranceNum 保单号
   * @return {Promise}
   */
  searchInsurance(insuranceNum) {
    return Http.post('/sys/order_insurance_query', {
      insurance_num: insuranceNum,
    });
  },

  // 展开保障期限中的区间选项
  flatProtectOptions(optionArr) {
    if (!optionArr) {
      return;
    }
    const newOptions = [];
    optionArr.forEach((op) => {
      // 若type等于2，表明是区间
      if (+op.type === 1) {
        newOptions.push(op);
      } else {
        let startNum = op.min;
        while (startNum <= op.max) {
          newOptions.push({
            value: startNum,
            step: 0,
            unit: op.unit,
            max: startNum,
            min: startNum,
            type: '1',
          });
          startNum += op.step;
        }

        if (startNum < op.max + op.step) {
          newOptions.push({
            value: op.max,
            step: 0,
            unit: op.unit,
            max: op.max,
            min: op.max,
            type: '1',
          });
        }
      }
    });
    return newOptions;
  },

};




// WEBPACK FOOTER //
// ./src/services/insurance-service.js